<app-new-password (passChanged)="onPassChanged($event)"></app-new-password>